module.exports = __webpack_public_path__ + "static/media/n3.ac2cb468.jpg";